import { Permission } from './permission.model';

export class Role {

  public id: string;
  public name?: string;
  public description?: string;
  public permissions?: Array<Permission> = [];

  static fromDto(r) {
    const role           = new Role();
    role.id              = r.id;
    role.name            = r.name;
    role.description     = r.description;
    role.permissions     = r.permissions || [];

    return role;
  }

}

export enum RolesLabelEnum {
  DRIVER = 'Driver',
  CARRIER_MANAGER = 'Carrier Manager',
  CHEP_MANAGER = 'CHEP Manager',
  PLANT_MANAGER = 'Plant Manager',
  ADMINISTRATOR = 'Administrator',
  POD_REVIEWER = 'POD Reviewer',
  OVERDUE_MANAGER = 'Overdue Manager',
  SUSTAINABILITY_MANAGER = 'Sustainability Manager'
}
